module.exports = __webpack_public_path__ + "static/media/icon_employment.80101fdb.svg";